module.exports = __webpack_public_path__ + "img/Weapon_84.009dc0e6.png";